import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from './Navbar';
import  Footer  from './Footer';
import Wpp from './Wpp';

// API proxied through Nginx - uses same domain and SSL cert
const api_url = process.env.REACT_APP_API_URL || window.location.origin;

function Services() {
    const [pricing, setPricing] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPricing = async () => {
            try {
                const response = await axios.get(`${api_url}/api/pricing`);
                setPricing(response.data);
            } catch (error) {
                console.error('Error fetching pricing:', error);
                // Fallback to default pricing if API fails
                setPricing({
                    tax: 249,
                    business: 349,
                    investment: 0,
                    llcCreation: 1450
                });
            } finally {
                setLoading(false);
            }
        };

        fetchPricing();
    }, []);

    if (loading) {
        return (
            <div className="min-vh-100 d-flex align-items-center justify-content-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <Navbar />
            <div id="layoutDefault">
                <div id="layoutDefault_content">
                    <main>
                        <header class="page-header-ui page-header-ui-dark bg-gradient-primary-to-secondary">
                            <div class="page-header-ui-content pt-10">
                                <div class="container px-5 text-center">
                                    <div class="row gx-5 justify-content-center">
                                        <div class="col-lg-8">
                                            <h1 class="page-header-ui-title mb-3">Our Services</h1>
                                            <p class="page-header-ui-text">Our product, priced to fit your specific needs</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="svg-border-rounded text-light">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"></path></svg>
                            </div>
                        </header>
                        <section class="bg-light py-10">
                            <div class="container px-5">
                                <div class="text-center mb-5">
                                    <h2>Tax</h2>
                                </div>
                                <div class="row gx-5">
                                    <div class="col-lg-4 mb-5 mb-lg-0">
                                    <div class="card pricing h-100">
                                <div class="card-body p-5">
                                    <div class="text-center">
                                        <div class="badge bg-light text-dark rounded-pill badge-marketing badge-sm">Non-Resident</div>
                                        <div class="pricing-price">
                                            <div className='starts_at_price'></div>
                                            <sup>$</sup>
                                            {pricing.nonResidentTax || 249}
                                        </div>
                                    </div>
                                    <ul class="fa-ul pricing-list">
                                        <li class="pricing-list-item">
                                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                            <span class="text-dark">Non-resident Individual Income Tax Return (Form 1040NR)</span>
                                        </li>
                                        <li class="pricing-list-item">
                                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                            <span class="text-dark">Income wage statement (Form W-2)</span>
                                        </li>
                                        <li class="pricing-list-item">
                                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                            <span class="text-dark">Interest and dividend earnings</span>
                                        </li>
                                        <li class="pricing-list-item">
                                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                            <span class="text-dark">Rental property</span>
                                        </li>
                                                                <li class="pricing-list-item">
                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                            <span class="text-dark">Work & Travel</span>
                        </li>
                        <li class="pricing-list-item">
                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                            <span class="text-dark">Prior tax return amendment (Form 1040X)</span>
                        </li>
                        <li class="pricing-list-item" style={{padding:'15px'}}>
                            <span class="text-dark">*If you received coronavirus payments (Stimulus check) contact one of our experts to correct your returns. It's important to note that such payments do not correspond to non-residents.</span>
                        </li>
                                    </ul>
                                </div>
                            </div>
                                    </div>
                                    <div class="col-lg-4 mb-5 mb-lg-0">
                                    <div class="card pricing h-100">
                                <div class="card-body p-5">
                                    <div class="text-center">
                                        <div class="badge bg-light text-dark rounded-pill badge-marketing badge-sm">Resident</div>
                                        <div class="pricing-price">
                                            <div className='starts_at_price'></div>
                                            <sup>$</sup>
                                            {pricing.residentTax || 349}
                                        </div>
                                    </div>
                                    <ul class="fa-ul pricing-list">
                                        <li class="pricing-list-item">
                                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                            <span class="text-dark">Resident Individual Income Tax Return (Form 1040)</span>
                                        </li>
                                        <li class="pricing-list-item">
                                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                            <span class="text-dark">Income wage statement (Form W2)</span>
                                        </li>
                                        <li class="pricing-list-item">
                                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                            <span class="text-dark">Interest and dividend earnings</span>
                                        </li>
                                        <li class="pricing-list-item">
                                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                            <span class="text-dark">Rental property</span>
                                        </li>
                                                                <li class="pricing-list-item">
                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                            <span class="text-dark">Stock trading</span>
                        </li>
                        <li class="pricing-list-item">
                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                            <span class="text-dark">Claim your Covid "Stimulus check"</span>
                        </li>
                                    </ul>
                                </div>
                            </div>
                                    </div>
                                    <div class="col-lg-4">
                                    <div class="card pricing h-100">
                                <div class="card-body p-5">
                                    <div class="text-center">
                                        <div class="badge bg-light text-dark rounded-pill badge-marketing badge-sm">Expatriate</div>
                                        <div class="pricing-price">
                                            <div className='starts_at_price'></div>
                                            <sup>$</sup>
                                            {pricing.expatriateTax || 449}
                                        </div>
                                    </div>
                                    <ul class="fa-ul pricing-list">
                                        <li class="pricing-list-item">
                                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                            <span class="text-dark">Foreign income exclusion and tax credit optimization</span>
                                        </li>
                                        <li class="pricing-list-item">
                                            <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                            <span class="text-dark">Foreign account reporting exceeding $10,000 cumulative during the year (Additional $100)</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                                    </div>
                                </div>
                                <div class="mt-5 text-center"><a class="btn btn-primary fw-500" href="/appointments">Get Started</a></div>
                            </div>
                        </section>
                        <hr class="my-0" />
                        <section class="bg-light py-10">
                            <div class="container px-5">
                                <div class="text-center mb-5">
                                    <h2>Investments</h2>
                                    <p class="lead">FREE investment consulting</p>
                                </div>
                                <div class="row g-0 align-items-center">
                                    <div class="col-lg-6 mb-5 mb-lg-0">
                                        <div class="card pricing">
                                            <div class="card-body p-5">
                                                <div class="badge bg-primary-soft rounded-pill badge-marketing badge-sm text-primary">Free</div>
                                                <div class="pricing-price">
                                                    <sup>Consulting</sup>
                                                </div>
                                                <ul class="fa-ul pricing-list">
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Investment consulting</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Invest in the financial market</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Investment visa advisory</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Short, medium and long-term investment plans</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Small capital investments</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Large capital investments</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="card-footer px-5">
                                                <a class="d-flex align-items-center justify-content-between" href="/appointments">
                                                    Schedule your call now!
                                                    <i class="fas fa-arrow-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="card pricing pricing-right bg-gray-800">
                                            <div class="card-body p-5">
                                                <div class="badge bg-transparent-light badge-marketing rounded-pill badge-sm">Personalized</div>
                                                <p class="card-text py-5">Need a personalized plan? Contact us directly and we can work together to design a plan that fits your specific needs.</p>
                                            </div>
                                            <div class="card-footer bg-gray-900 px-5">
                                                <a class="text-white-50 d-flex align-items-center justify-content-between" href="/appointments">
                                                    Contact an expert
                                                    <i class="fas fa-arrow-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <hr class="my-0" />
                        <section class="bg-light py-10">
                            <div class="container px-5">
                                <div class="text-center mb-5">
                                    <h2>Business</h2>
                                </div>
                                <div class="row g-0 align-items-center">
                                    <div class="col-lg-4 mb-5 mb-lg-0">
                                        <div class="card pricing pricing-left">
                                            <div class="card-body p-5">
                                                <div class="text-center">
                                                    <div class="badge bg-light text-dark rounded-pill badge-marketing badge-sm">Admin</div>
                                                    <div class="pricing-price">
                                                        <div className='starts_at_price'></div>
                                                        <sup>$</sup>
                                                        {pricing.adminServices || 199}
                                                        <span class="pricing-price-period">/month</span>
                                                    </div>
                                                </div>
                                                <ul class="fa-ul pricing-list">
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Bookkeeping</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Web development / cloud pages and applications</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Marketing</span>
                                                    </li>
                                                </ul>
                                                <div style={{textAlign:'center'}}><a class="btn btn-primary fw-500 me-3 my-2" href="/appointments">Free consultation</a></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 mb-5 mb-lg-0">
                                        <div class="card pricing py-4 z-1">
                                            <div class="card-body p-5">
                                                <div class="text-center">
                                                    <div class="badge bg-primary-soft rounded-pill badge-marketing badge-sm text-primary">Business Tax</div>
                                                    <div class="pricing-price">
                                                        <div className='starts_at_price'></div>
                                                        <sup>$</sup>
                                                        {pricing.businessTax || 549}
                                                    </div>
                                                </div>
                                                <ul class="fa-ul pricing-list">
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Corporate tax return (Form 1120)</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Partnership tax return (Form 1065)</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">S-Corporation tax return (Form 1120-S)</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Optimal structure and organization</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Informational return for corporations with at least 25% foreign owners (Form 5472)</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Informational return for U.S. persons owning foreign corporations</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Form K-1</span>
                                                    </li>
                                                </ul>
                                                <div style={{textAlign:'center'}}><a class="btn btn-primary fw-500 me-3 my-2" href="/appointments">Free consultation</a></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 mb-5 mb-lg-0">
                                        <div class="card pricing pricing-right">
                                            <div class="card-body p-5">
                                                <div class="text-center">
                                                    <div class="badge bg-secondary-soft rounded-pill badge-marketing badge-sm text-secondary">LLC</div>
                                                    <div class="pricing-price">
                                                        <sup>$</sup>
                                                        {pricing.llcCreation || 1450}
                                                    </div>
                                                </div>
                                                <ul class="fa-ul pricing-list">
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Open your business (LLC)</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Open your bank account</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Articles of incorporation design</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Address and representative in Wyoming or Delaware</span>
                                                    </li>
                                                </ul>
                                                <div style={{textAlign:'center'}}><a class="btn btn-primary fw-500 me-3 my-2" href="/appointments">Free consultation</a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <hr class="my-0" />
                        <section class="bg-light py-10">
                            <div class="container px-5">
                                <div class="text-center mb-5">
                                    <h2>Technology</h2>
                                    <p class="lead">Everything your business needs in the IT world</p>
                                </div>
                                <div class="row g-0 align-items-center ">
                                    <div class="col-lg-6 mb-5 mb-lg-0">
                                        <div class="card pricing">
                                            <div class="card-body p-5">
                                                <div class="badge bg-primary-soft rounded-pill badge-marketing badge-sm text-primary">Free consulting</div>
                                                <div class="pricing-price">
                                                    <sup>Our IT services</sup>
                                                </div>
                                                <ul class="fa-ul pricing-list">
                                                <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Create and register your brand and logo</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Register your domain</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Create and host your online application/website</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Database management</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Technical support</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">E-commerce</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Cybersecurity</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Online marketing</span>
                                                    </li>
                                                    <li class="pricing-list-item">
                                                        <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span>
                                                        <span class="text-dark">Email newsletter</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="card-footer px-5">
                                                <a class="d-flex align-items-center justify-content-between" href="/appointments">
                                                    Let's get started!
                                                    <i class="fas fa-arrow-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="card pricing pricing-right bg-gray-800 ">
                                            <div class="card-body p-5">
                                                <div class="badge bg-transparent-light badge-marketing rounded-pill badge-sm">Need to hire IT professionals?</div>
                                                <p class="card-text py-5">We help form teams with IT professionals to work for your business from our office in Argentina.</p>
                                            </div>
                                            <div class="card-footer bg-gray-900 px-5">
                                                <a class="text-white-50 d-flex align-items-center justify-content-between" href="/appointments">
                                                    Contact an expert
                                                    <i class="fas fa-arrow-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <hr class="my-0" />
                        <section class="bg-light pt-10">
                            <div class="container px-5">
                                <div class="row gx-5 align-items-center mb-10">
                                    <div class="col-lg-6">
                                        <div class="h4 fw-normal">Ask us anything you want</div>
                                    </div>
                                    <div class="col-lg-6 text-lg-end">
                                        <a class="btn btn-primary fw-500 me-3 my-2" href="/contact">Contact us</a>
                                        <a class="btn btn-white fw-500 shadow my-2" href="/appointments">Schedule a free call</a>
                                    </div>
                                </div>
                                <div class="row gx-5">
                                    <div class="col-lg-6 z-1 mb-5 mb-lg-n5">
                                        <a class="card text-decoration-none h-100 lift" href="#!">
                                            <div class="card-body py-5">
                                                <div class="d-flex align-items-center">
                                                    <div class="ms-4">
                                                        <h5 class="text-primary">Work smarter</h5>
                                                        <p class="card-text text-gray-600">Save time and money with our products. Focus 100% on doing what you love most.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-lg-6 z-1 mb-10 mb-lg-n5">
                                        <a class="card text-decoration-none h-100 lift" href="#!">
                                            <div class="card-body py-5">
                                                <div class="d-flex align-items-center">
                                                    <div class="ms-4">
                                                        <h5 class="text-secondary">Personalized just for you</h5>
                                                        <p class="card-text text-gray-600">Tell us exactly what you need and we'll design a solution precisely for you.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="svg-border-waves text-dark">

                            </div>
                        </section>
                        <section class="bg-white py-10">
                            <div class="container px-5">
                                <div class="row gx-5 justify-content-center">
                                    <div class="col-lg-10">
                                        <div class="text-center">
                                            <h2>Ready to get started?</h2>
                                            <p class="lead">Contact us today to schedule your consultation</p>
                                            <a class="btn btn-primary fw-500 me-2" href="/appointments">
                                                Book Appointment
                                                <i class="ms-2" data-feather="arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div>
                <div id="layoutDefault_footer">
                    <Footer />
                </div>
            </div>
            <Wpp />
        </>
    );
}

export default Services;